import { useQuery } from "@tanstack/react-query";

import { postPurchaseQueryOptions } from "@/domains/surveys/factories/post-purchase-query-options";

export const usePostPurchaseRecommendations = (flowUuid: string) => {
  return useQuery({
    ...postPurchaseQueryOptions.recommendations(flowUuid),
    /* Forces retries on all http error status codes.
    This is needed because the recommendations endpoint will return 404's
    until it receives the payload from Formsort answers. */
    retry: 10,
  });
};
